export default __webpack_public_path__ + "static/media/2.b2ec5991.png";